import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import Sidebar from "../../../../partials/aside/Sidebar";
import StepsAddCampaigns from "../../StepsAddCampaigns";
import validateFormAddCampaign from "../../../../../validtions/forms/campaign/banner/add";
import {
  DatePicker,
  DateTimePicker,
  DateRangePicker,
  DateTimeRangePicker,
} from "react-advance-jalaali-datepicker";
import httpService from "../../../../../services/httpServices/httpServices";
import TypeGroupCampaign from "../../TypeGroupCampaign";
import SelectTableHourCampaigns from "../../SelectTableHourCampaigns";
import helperNumber from "./../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";

function AddCampaign() {
  let tagSelectDateCampaignContainer;
  let tagSelectTimeCampaignContainer;
  const history = useHistory();
  const [tagCategories, setTagCategories] = useState(<></>);
  const [message, setMessage] = useState();

  let messageTag;

  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const getCategoriesUserSitesPublisher = async () => {
    let categories = await sendRequestGetCategoriesUserSitesPublisher();
    categories = filterCategoriesUserSitesPublisherType(
      categories,
      TypeGroupCampaign.typeGroupPublisher.NATIVE
    );

    setTagCategories(generateTagCategories(categories));
  };

  const filterCategoriesUserSitesPublisherType = (categories, type) => {
    return categories.filter((category) => {
      if (category.type == type) {
        return category;
      }
    });
  };

  const [hoursAtDays, setHoursAtDays] = useState({
    sa: [],
    su: [],
    mo: [],
    tu: [],
    we: [],
    th: [],
    fr: [],
  });
  const hoursAtDaysChangeHandle = (hoursArray) => {
    setHoursAtDays(hoursArray);
  };

  useEffect(() => {
    tagSelectDateCampaignContainer = document.getElementById(
      "select-date-campaign-container"
    );
    tagSelectTimeCampaignContainer = document.getElementById(
      "select-time-campaign-container"
    );
    getCategoriesUserSitesPublisher();
  }, []);

  const generateTagCategories = (categories) => {
    return categories.map((category, index) => {
      return (
        <>
          <option key={index} value={category.id}>
            {category.name}
          </option>
        </>
      );
    });
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetCategoriesUserSitesPublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    let categoryAllPublisher;
    try {
      categoryAllPublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/category-user-site-publishers",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return categoryAllPublisher.data.data;
  };

  let items = [
    {
      title: "نوع کمپین",
      status: true,
      link: "/campaigns/all-type",
    },
    {
      title: "نوع کمپین همسان",
      status: true,
      link: "/campaigns/all-type-native",
    },
    {
      title: "تنظیمات کمپین",
      status: true,
      link: "/campaigns/native/add-simple",
    },
  ];

  const changeDateStatus = (e) => {
    const dateStatus = e.target.defaultValue;
    if (dateStatus == 1) {
      tagSelectDateCampaignContainer.classList.remove("d-none");
      tagSelectDateCampaignContainer.classList.add(
        "d-flex",
        "flex-column",
        "flex-md-row"
      );
    } else if (dateStatus == 0) {
      tagSelectDateCampaignContainer.classList.remove(
        "d-flex",
        "flex-column",
        "flex-md-row"
      );
      tagSelectDateCampaignContainer.classList.add("d-none");
    }
  };

  const changeTimeStatus = (e) => {
    const timeStatus = e.target.defaultValue;
    if (timeStatus == 1) {
      tagSelectTimeCampaignContainer.classList.remove("d-none");
      tagSelectTimeCampaignContainer.classList.add(
        "d-flex",
        "flex-column",
        "flex-md-row"
      );
    } else if (timeStatus == 0) {
      tagSelectTimeCampaignContainer.classList.remove(
        "d-flex",
        "flex-column",
        "flex-md-row"
      );
      tagSelectTimeCampaignContainer.classList.add("d-none");
    }
  };

  const sendForm = async (e) => {
    e.preventDefault();

    const dataForm = getFormData();

    if (validateFormAddCampaign(dataForm) != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validateFormAddCampaign(dataForm),
        class_icon: "fa fa-exclamation-triangle",
      });

      return;
    }

    if (await sendRequestAddCampaign(dataForm)) {
      history.push("/campaigns/all");
    }
  };

  const getFormData = () => {
    return {
      name: document.querySelector("#name-campaign").value,
      category_id: document.querySelector("#category-campaign").value,
    };
  };

  const sendRequestAddCampaign = async (campaignData) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/campaign/native/simple",
        campaignData,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return true;
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  تنظیمات نمایش کمپین همسان ساده
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <StepsAddCampaigns items={items} />

              {messageTag}

              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 ">
                    <form onSubmit={sendForm}>
                      <div className="col-12 col-md-6  ">
                        <label>نام کمپین</label>
                        <input
                          className="form-control"
                          id="name-campaign"
                          type="text"
                        />
                      </div>

                      <div className="col-12 col-md-6 py-4 ">
                        <label>گروه نمایش دهندگان</label>
                        <select id="category-campaign" className="form-control">
                          <option>انتخاب کنید</option>
                          {tagCategories}
                        </select>
                      </div>

                      {/* <div className="col-12 col-md-6 col-lg-3    ">
                        <label>چه تاریخی؟</label>
                        <div className="d-flex justify-content-between">
                          <span>همیشه</span>
                          <span>
                            <input
                              type="radio"
                              onChange={changeDateStatus}
                              name="when-date"
                              className="hover"
                              value="0"
                              defaultChecked={true}
                            />
                          </span>
                          <span>انتخاب</span>
                          <span>
                            <input
                              type="radio"
                              onChange={changeDateStatus}
                              name="when-date"
                              className="hover"
                              value="1"
                            />
                          </span>
                        </div>
                      </div>

                      <div
                        className="col-12 col-md-6 d-none  "
                        id="select-date-campaign-container"
                      >
                        <div className="  pl-lg-2">
                          <div>از تاریخ</div>
                          <div className="custom-data-picker">
                            <DatePicker
                              placeholder="انتخاب تاریخ"
                              format="jYYYY/jMM/jDD"
                              className="input-text-data-picker"
                            />
                          </div>
                        </div>
                        <div>
                          <div>تا تاریخ</div>
                          <div className="custom-data-picker">
                            <DatePicker
                              placeholder="انتخاب تاریخ"
                              format="jYYYY/jMM/jDD"
                              className="input-text-data-picker"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-md-6 col-lg-3  ">
                        <label>چه زمانی؟</label>
                        <div className="d-flex     justify-content-between">
                          <span>هر زمانی</span>
                          <span>
                            <input
                              type="radio"
                              className="hover"
                              name="when-time"
                              onChange={changeTimeStatus}
                              defaultChecked={true}
                              value="0"
                            />
                          </span>
                          <span>انتخاب</span>
                          <span>
                            <input
                              type="radio"
                              className="hover"
                              name="when-time"
                              onChange={changeTimeStatus}
                              value="1"
                            />
                          </span>
                        </div>
                      </div>

                      <div
                        className="col-12 col-md-6 d-none  "
                        id="select-time-campaign-container"
                      >
                        <SelectTableHourCampaigns
                          hoursAtDays={hoursAtDays}
                          hoursAtDaysChangeHandle={hoursAtDaysChangeHandle}
                        />
                      </div> */}

                      <div className="col-12 col-md-6 ">
                        <button type="submit" className="btn btn-primary">
                          اضافه کردن کمپین
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
export default AddCampaign;
